import { Alert, Box, Typography } from '@mui/material';
import type { MetricsFrameworkTabId } from '../types';
import { getPageConfig } from '../pageConfigs';
import { useMetricsFrameworkContext } from '../context/MetricsFrameworkContext';
import PageRenderer from './PageRenderer';

type Props = { view: MetricsFrameworkTabId };

/** Temporary: hide Looking Ahead metrics until the tab is ready. */
const LOOKING_AHEAD_COMING_SOON = true;

export default function MetricsFrameworkTabView({ view }: Props) {
  const { filters } = useMetricsFrameworkContext();
  const page = getPageConfig(view);

  if (view === 'looking-ahead' && LOOKING_AHEAD_COMING_SOON) {
    return (
      <Box
        sx={{
          py: 8,
          px: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 280,
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}>
          Coming Soon
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 360 }}>
          Looking Ahead is under construction. Check back soon.
        </Typography>
      </Box>
    );
  }

  if (!filters) {
    return (
      <Box sx={{ py: 2 }}>
        <Alert severity="info">Select a dealer to load metrics.</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ pb: 4 }}>
      <PageRenderer page={page} filters={filters} />
    </Box>
  );
}
